<template>
  <div class="animated fadeIn equipmentList bgV2">
    <b-row>
      <b-col md="12">
        <div class="boxShadow heig-frame mt-16 border-top-right-radius">
          <div class="padding-13 padding-scroll pt-15 heig-frame-child">
            <gofix-default-table :settings="tableConfig"
                                 :table-items="tableItems"
                                 @load-items="getTableData"
                                 @row-click="editItem"
                                 ref="gofixTable">
              <template slot="gofix_table:updated_at" slot-scope="data">
                {{data.item.updated_at  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
              </template>
            </gofix-default-table>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-modal :no-close-on-backdrop="true" id="modal-reading" title="Edit App Version" hide-footer :centered="true" ref="modal-reading">
      <b-form class="formV2">
        <b-row>
          <b-col md="12">
            <gofix-form-dropdown
                    label="Platform"
                    :filterable="false"
                    :clearable="false"
                    :required="true"
                    v-model="dataUpdate.flatform"
                    vLabel="reference_value_text"
                    :reduce="option => option.reference_value_text"
                    :options="platformOptions">
            </gofix-form-dropdown>
            <gofix-form-input label="App Version" v-model="dataUpdate.version"></gofix-form-input>
            <gofix-form-dropdown
                    label="Force Update"
                    :filterable="false"
                    :required="true"
                    :clearable="false"
                    v-model="dataUpdate.force_updatero"
                    vLabel="reference_value_text"
                    :reduce="option => option.reference_value_text"
                    :options="forceUpdateOptions">
            </gofix-form-dropdown>
          </b-col>
        </b-row>
      </b-form>

      <b-button-group class="text-right d-block">
        <gofix-button :disabled="!$checkRole($accessModule.mobile_app_versioning, 'update')" label="SUBMIT" @click="save" :loading="isAction" noBorder></gofix-button>
      </b-button-group>
    </b-modal>
  </div>
</template>
<script>
  import { filters } from '@/_filterVar.js'
  export default {
    name: 'reading-log',
    data () {
      return {
        tableConfig:{
          name: 'master-table-mobile-app-versioning',
          controls:{
            delete:false,
            create: false
          },
          filter: JSON.parse(JSON.stringify(filters['app_versioning'])),
          page: 1,
          limit: 100,
          total: 0,
        },
        tableItems: [],
        isAction: false,
        pages: {
          isCMS: '1',
          limit: 100,
          page: 1,
          totalPage: 0,
          filter: null
        },
        items: [],
        idUpdate: '',
        dataUpdate: {
          flatform: '',
          version: '',
          force_updatero: ''
        },
        platformOptions:[],
        forceUpdateOptions:[],
      }
    },
    async created(){
      this.getPlatformOptions();
      this.getForceUpdateOptions();
    },
    methods:{
      async getTableData(callback) {
        const { tableRequest , resolve,reject } = await callback();
        await this.$store.dispatch("AppVersionController/getList", tableRequest)
                .then(response => {
                  this.tableItems = response.data.data.items;
                  this.tableConfig.total = response.data.data.total;
                  resolve(response.data.data);
                })
                .catch(err => {
                  console.log(err);
                  this.$bvToast.toast("Can not load data", {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                  })
                  reject();
                })
      },
      editItem(value) {
        this.dataUpdate.flatform = value.flatform;
        this.dataUpdate.version = value.version;
        this.dataUpdate.force_updatero = value.force_updatero;
        this.idUpdate = value.id;
        this.$refs['modal-reading'].show()
      },
      save() {
        this.isAction = true
        if(!this.dataUpdate.flatform) {
          this.$bvToast.toast("Please select one Platform!!", {
            title: `Notification`,
            autoHideDelay: 3000,
            variant: 'danger',
            solid: true
          });

          this.isAction = false
          return false;
        }

        if(!this.dataUpdate.version) {
          this.$bvToast.toast("Please enter version!!", {
            title: `Notification`,
            autoHideDelay: 3000,
            variant: 'danger',
            solid: true
          });

          this.isAction = false
          return false;
        }

        if(!this.dataUpdate.force_updatero) {
          this.$bvToast.toast("Please select one Force Update!!", {
            title: `Notification`,
            autoHideDelay: 3000,
            variant: 'danger',
            solid: true
          });

          this.isAction = false
          return false;
        }

        if(!this.idUpdate) {
          this.$bvToast.toast("Please select one line to updated!!", {
            title: `Notification`,
            autoHideDelay: 3000,
            variant: 'danger',
            solid: true
          });

          this.isAction = false
          return false;
        }

        this.$store.dispatch("AppVersionController/updateAppVersion", { id: this.idUpdate, data: this.dataUpdate })
                .then( async data =>{
                  this.isAction = false
                  this.$bvToast.toast( this.$notificationV2('editing', 'app_version'), {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'success',
                    solid: true
                  })
                  this.$refs['modal-reading'].hide();
                  this.$refs.gofixTable.reloadTableKeepFilter();
                })
                .catch(error=>{
                  this.$bvToast.toast("Error", {
                    title: `Notification`,
                    autoHideDelay: 3000,
                    variant: 'danger',
                    solid: true
                  });
                })
      },
      getPlatformOptions(){
        let filter = {reference_type: "Platform"};
        let params = {
          filter: filter,
          limit: -1,
          sortColumn: "id",
          sortDirection: "asc",
        };
        this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                  this.platformOptions = response.items;
                })
      },
      getForceUpdateOptions(){
        let filter = {reference_type: "Force Update"};
        let params = {
          filter: filter,
          limit: -1,
          sortColumn: "id",
          sortDirection: "asc",
        };
        this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                  this.forceUpdateOptions = response.items;
                })
      },
    }
  }
</script>
